import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=5fa6bd50"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"
import style0 from "./Intro.vue?vue&type=style&index=0&id=5fa6bd50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports